import { attribute } from './constants';
export var getFieldListValues = function getFieldListValues(field) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#';
  var listValuesText = field[attribute.LIST_VALUES];

  if (!listValuesText) {
    return listValuesText;
  }

  return listValuesText.trim().split(delimiter).map(function (value) {
    return value.trim();
  });
};
export var transformFieldListValues = function transformFieldListValues() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var destinationAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : attribute.LIST_VALUES;
  fields.forEach(function (f) {
    if (typeof f[attribute.LIST_VALUES] === 'string') {
      f[destinationAttribute] = getFieldListValues(f);
    }
  });
};